import { createContext, type ReactNode, useContext, useEffect } from 'react'
import { AuthContext, type IAuthContext } from 'react-oauth2-code-pkce'
import { FullPage as Loading } from '@/components/loading'
import { useQuery } from '@apollo/client/react'
import { graphql } from '@/gql'
import type { ResultOf } from '@graphql-typed-document-node/core'

type CurrentUserCtx = {
  currentUser: ResultOf<typeof CurrentUserQuery>['currentUser'] | null
}

interface Props {
  children: ReactNode
}

const CurrentUserQuery = graphql(`
  query CurrentUser {
    currentUser {
      id
      email
    }
  }
`)

export const CurrentUserContext = createContext<CurrentUserCtx>({
  currentUser: null
})

export const CurrentUserProvider = ({
  children,
}: Props) => {
  const { error, logIn } = useContext<IAuthContext>(AuthContext)
  const { data, loading } = useQuery(CurrentUserQuery)

  const currentUser = data?.currentUser || null

  useEffect(() => {
    if (error?.match(/Bad authorization state/)) { logIn(undefined, undefined, 'redirect') }
  }, [error, logIn])

  if (loading) return <Loading />

  return (
    <CurrentUserContext.Provider value={{ currentUser }}>
      { children }
    </CurrentUserContext.Provider>
  )
}
